import CryptoJS from "crypto-js";

function decrypt(token, tokenKey, tokenIV, algorithm = "aes-256-cbc") {
    try {
        // Use first 32 chars for key, first 16 for IV (matches Node.js Buffer behavior)
        const key = tokenKey.slice(0, 32);
        const iv = tokenIV.slice(0, 16);

        const keyBytes = CryptoJS.enc.Utf8.parse(key);
        const ivBytes = CryptoJS.enc.Utf8.parse(iv);

        // Decrypt using CryptoJS AES (matches Node.js aes-256-cbc)
        const bytes = CryptoJS.AES.decrypt(token, keyBytes, {
            iv: ivBytes,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        let decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // Your original post-processing logic for user_input
        decrypted = decrypted.replace(/"user_input": "([^"]*)"/g, (match, p1) => {
            const replacedInput = p1.replace(/\n/g, "\\n");
            return `"user_input": "${replacedInput}"`;
        });

        return {
            status: true,
            message: "Decryption successful!",
            data: decrypted
        };
    } catch (error) {
        return { status: false, message: error.message };
    }
}

function encrypt(data, tokenKey, tokenIV, algorithm = "aes-256-cbc") {
    console.log("🚀 ~ encrypt ~ data:", data)
    if (algorithm !== "aes-256-cbc") {
        throw new Error("Unsupported algorithm");
    }

    const key = CryptoJS.enc.Utf8.parse(tokenKey); // must be 32 bytes for AES-256
    const iv = CryptoJS.enc.Utf8.parse(tokenIV);   // must be 16 bytes for CBC

    const encrypted = CryptoJS.AES.encrypt(
        typeof data === "string" ? data : JSON.stringify(data),
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    // return Base64 string (common for APIs)
    return encrypted.toString();
}
export {
    decrypt,
    encrypt,
};
